import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './RefundExchangeFallback.scss';

const RefundExchangeFallback = props => {
    const { dataLocale: { WANT_TO_EXCHANGE_REFUND, DOWNLOAD_OUR_MOBILE_APP, GO_TO_APP_MY_ACCOUNTS, GO, TO, LKDOTCOM, LK, AS, PS } } = props;
    return (
        <div className="re-container display-flex">
            <div className="logo">
                <Link to="/">
                    <img src="https://static1.lenskart.com/media/desktop/img/site-images/logo.svg" alt={LK} />
                </Link>
            </div>
            <div className="info text-black text-center bg-color-white">
                <div className="font-medium fs20 margin-b8">
                    {WANT_TO_EXCHANGE_REFUND}
                </div>
                <div className="font-medium fs20 margin-b8">
                    {DOWNLOAD_OUR_MOBILE_APP}
                </div>
                <div className="fs16">
                    {GO_TO_APP_MY_ACCOUNTS}
                </div>
                <div className="app-icons margin-t30 display-flex">
                    <a href="https://onelink.to/lenskart2"><img className="app-icon" src="https://static.lenskart.com/media/desktop/img/site-images/applestore.svg" alt={AS} /></a>
                    <a href="https://onelink.to/lenskart2"><img className="app-icon" src="https://static.lenskart.com/media/desktop/img/site-images/googleplay.svg" alt={PS} /></a>
                </div>
            </div>
            <Link to="/" className="home-link margin-t10 fs14 text-capitalize">{GO} {TO} {LKDOTCOM}</Link>
        </div>
    );
};

const mapStateToProps = state => ({
    dataLocale: state.locale
});

export default connect(mapStateToProps)(RefundExchangeFallback);
